import React from 'react';

import api     from '../../../../../api';
import values  from '../../../../../values';
import Context from '../../../../../context';

import CityScreen from '..';

import { useQuery          } from 'react-query';
import { TModal            } from '../../../../../types/common.type';
import { locationNamespace } from '../../../../../types/location.namespace';
import {updateCity} from "../../../../../api/method.patch/administrator";
import successHandler from "../../../../../utils/successHandler";

const CityContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedCity, setSelectedCity] = React.useState<locationNamespace.city.index | undefined>(undefined);
  const [requestCity , setRequestCity ] = React.useState<locationNamespace.city.request>({
    limit: 10,
    page : 1 ,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getCities = useQuery(
    [values.useQueryKeys.locationGetCity, requestCity],
    () => api.get.common.searchCity(requestCity)
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(event: locationNamespace.city.create): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createCity(event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(event: locationNamespace.city.update): Promise<void> {
    setIsLoading(true);
    if (!selectedCity) return;
    const result = await api.patch.administrator.updateCity(selectedCity?._id, event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function deleteFunction(): Promise<void> {
    setIsLoading(true);
    if (!selectedCity) return;
    const result = await api.dele.administrator.deleteCity(selectedCity?._id);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.Location.City.Provider value={{
      showModal   ,
      isLoading   ,
      requestCity ,
      selectedCity,
      setShowModal   ,
      setIsLoading   ,
      createFunction ,
      updateFunction ,
      deleteFunction ,
      setRequestCity ,
      setSelectedCity,
    }}>
      <CityScreen rqData={getCities} />
    </Context.Location.City.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default CityContainer;
